<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-row>
      <v-col cols="12">
        <v-alert v-if="error_alert" text prominent type="error" icon="mdi-cloud-alert">{{ error_alert }}</v-alert>
        <v-alert
            v-if="success_alert"
            text
            prominent
            type="success"
            icon="mdi-cloud-alert"
        >{{ success_alert }}
        </v-alert
        >
      </v-col>
      <v-col cols="6">
        <v-card-title>
          Consultancy Setup
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <template>
            <v-text-field
                v-model="cs_search"
                prepend-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                outlined
                dense
            ></v-text-field>
          </template>
        </v-card-title>

        <v-card>
          <v-data-table
              :headers="consultancySetupHeaders"
              :items="consultancyData"
              class="elevation-1"
              :search="cs_search"
              dense
              mobile-breakpoint="0"
              :loading="loading_status"
              loading-text="Loading... Please wait"
          >
            <template v-slot:item.cs_name="{ item }">
              {{ item.cs_full_name ? item.cs_full_name : item.cs_name }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                      @click="get_update(item)"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      class="ma-2"
                      color="orange"
                      label
                      outlined
                      small
                  >
                    <v-icon> mdi-pencil</v-icon>
                  </v-chip>
                </template>
                <span>Edit</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card-title>
          Investigation Discount
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <template>
            <v-text-field
                v-model="inv_dis_search"
                prepend-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                outlined
                dense
            ></v-text-field>
          </template>
        </v-card-title>

        <v-card>
          <v-data-table
              :headers="investigationDiscountHeaders"
              :items="investigationDiscountData"
              class="elevation-1"
              :search="inv_dis_search"
              dense
              mobile-breakpoint="0"
              :loading="loading_status"
              loading-text="Loading... Please wait"
          >
            <template v-slot:item.actions="{ item }">
              <v-tooltip top >
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                      @click="get_invupdate(item)"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      class="ma-2"
                      color="orange"
                      label
                      outlined
                      small
                  >
                    <v-icon> mdi-pencil</v-icon>
                  </v-chip>
                </template>
                <span>Edit</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <template>
      <div class="text-center">
        <v-dialog v-model="consultancy_setup_dialog" width="500">
          <v-card>
            <v-card-title class="text-h6 grey lighten-2">
              Consultancy Setup: &nbsp;
              <v-chip v-if="consultDataUpdate.cs_full_name" dark color="green" label outlined>
                {{ consultDataUpdate.cs_full_name }}
              </v-chip>
            </v-card-title>
            <template>
              <v-form>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                          v-model="consultDataUpdate.cs_description"
                          outlined
                          dense
                          label="Description"
                          required
                          type="number"
                          :min="0"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                          v-model="consultDataUpdate.cs_calculate_type"
                          outlined
                          dense
                          label="Type"
                          required
                          readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </template>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="consultancy_setup_dialog = false"> Cancel</v-btn>
              <v-btn color="primary" text @click="consultancy_setup_data_submit()"> Update</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <template>
      <div class="text-center">
        <v-dialog v-model="investigation_discount_dialog" width="500">
          <v-card>
            <v-card-title class="text-h6 grey lighten-2">
              Investigation Discount Setup: &nbsp;
              <v-chip v-if="invDiscountUpdate.invs_name" dark color="green" label outlined>
                {{ invDiscountUpdate.invs_name }}
              </v-chip>
            </v-card-title>
            <template>
              <v-form>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                          v-model="invDiscountUpdate.invs_description"
                          outlined
                          dense
                          label="Description"
                          required
                          type="number"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                          v-model="invDiscountUpdate.invs_calculate_type"
                          outlined
                          dense
                          label="Type"
                          required
                          readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </template>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="investigation_discount_dialog = false"> Cancel</v-btn>
              <v-btn color="primary" text @click="investigation_discount_data_submit()"> Update</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>

  </div>
</template>

<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";


export default {
  data() {
    return {
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Administrative",
          disabled: true,
        },
        {
          text: "Fee & Ratio Setup",
          disabled: true,
        },
      ],
      cs_search: "",
      inv_dis_search: "",
      consultancy_setup_dialog: false,
      investigation_discount_dialog: false,
      error_alert: null,
      success_alert: null,
      loading_status: true,
      consultancyData: [],
      consultancySetupHeaders: [
        {text: "Name", value: "cs_name"},
        {text: "Description", value: "cs_description"},
        {text: "Type", value: "cs_calculate_type"},
        {text: "Action", value: "actions", sortable: false},
      ],
      investigationDiscountData: [],
      investigationDiscountHeaders: [
        {text: "Name", value: "invs_name"},
        {text: "Description", value: "invs_description"},
        {text: "Type", value: "invs_calculate_type"},
        {text: "Action", value: "actions", sortable: false},
      ],
      consultData: {
        id: null,
        cs_name: null,
        cs_description: null,
        cs_calculate_type: null,
        cs_status: null,
      },
      consultDataUpdate: {
        id: null,
        cs_name: null,
        cs_description: null,
        cs_calculate_type: null,
      },
      invDiscountUpdate: {
        id: null,
        invs_name: null,
        invs_description: null,
        invs_calculate_type: null,
      },
    };
  },
  // Fetches posts when the component is created.
  created() {
    let storedGroups = localStorage.getItem("userGroups") || "";
    let userGroups = storedGroups
        .split(",")
        .map(g => Number(g.trim()))
        .filter(g => !isNaN(g));

    let permittedGroups = [1, 8]; // Admin=1, Manager=8
    let hasAccess = userGroups.some(group => permittedGroups.includes(group));

    if (hasAccess) {
      console.log("Access Granted",hasAccess);
    } else {
      this.loadingstatus = false;
      this.error_alert = "Invalid Request";
      return false;
    }
    this.get_consultancy_setup_data();
    this.get_investigation_data();
  },
  methods: {
    get_consultancy_setup_data() {
      atshq
          .get("administrative/fee-ratio-data")
          .then((response) => {
            this.consultancyData = response.data.consultancyData;
            this.loading_status = false;
          })
          .catch((e) => {
            this.error_alert.push(e);
          });
    },
    get_investigation_data() {
      atshq.get("administrative/investigation-discount").then((response) => {
        this.investigationDiscountData = response.data.investigationDiscounts;
        console.log(this.investigationDiscountData)
        this.loading_status = false;
      })
          .catch((e) => {
            this.error_alert.push(e);
          })
    },

    get_update(item) {
      this.consultancy_setup_dialog = true;
      this.consultDataUpdate.id = item.id;
      this.consultDataUpdate.cs_full_name = item.cs_full_name;
      this.consultDataUpdate.cs_description = item.cs_description;
      this.consultDataUpdate.cs_calculate_type = item.cs_calculate_type;
    },
    get_invupdate(item) {
      this.investigation_discount_dialog = true;
      this.invDiscountUpdate.id = item.id;
      this.invDiscountUpdate.invs_name = item.invs_name;
      this.invDiscountUpdate.invs_description = item.invs_description;
      this.invDiscountUpdate.invs_calculate_type = item.invs_calculate_type;
    },

    consultancy_setup_data_submit() {
      if (confirm("are you sure?"))
        if (this.consultDataUpdate.id) {
          atshq
              .put("administrative/fee-ratio-data/" + this.consultDataUpdate.id, {
                data: this.consultDataUpdate,
                user_id: localStorage.getItem("userId"),
              })
              .then((res) => {
                this.$noty.success(res.data.message);
                this.get_consultancy_setup_data();
                this.consultancy_setup_dialog = false;
              })
              .catch((e) => {
                this.$noty.error(e.response.data.message);
              })
        }
    },
    investigation_discount_data_submit() {
      if (confirm("are you sure?"))
        if (this.invDiscountUpdate.id) {
          atshq
              .put("administrative/investigation-discount-update/" + this.invDiscountUpdate.id, {
                invdata: this.invDiscountUpdate,
                user_id: localStorage.getItem("userId"),
              })
              .then((res) => {
                this.$noty.success(res.data.message);
                this.get_investigation_data();
                this.investigation_discount_dialog = false;
              })
              .catch((e) => {
                this.$noty.error(e.response.data.message);
              })
        }
    },
  },
};
</script>
